module.exports = __webpack_public_path__ + "static/media/interrogative_and_indefinite_pronouns0_img.6033a2da.JPG";